// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__lbm9d","row":"Node_row__3w6he","label":"Node_label__3AcNK","footer":"Node_footer__1ncrz"};